import React, { useState, useEffect, useContext } from 'react';
import './style.less';

const AlexaUserInvitationConfirmationPage = (props) => {
    return (
        <div className="alexa-invite-confirmation-page relative-list">
            <div>
                <img
                    className="speak2-logo"
                    src="https://f.hubspotusercontent40.net/hubfs/8458943/Mark-Only@0.5x.jpg"
                    alt="Speak2 Family"
                    height="100"
                />
            </div>
            <p className="blue-text">
                <strong className="one-five-em">YOU'RE CONNECTED!</strong>
            </p>
            <p className="blue-text">
                <strong className="one-four-em">To get started, say "Alexa, open Speak2"</strong>​{' '}
            </p>
            <div className="bar" align="center" width="80%" />​
            <p className="blue-text">Below are some things you can do with Alexa and Speak2!</p>​
            <p className="image-section-p">
                <img src="https://f.hubspotusercontent40.net/hubfs/8458943/centered-bubble-1.png" alt="Send Messages" />
            </p>
            <div className="bar" align="center" width="80%" />
            <p className="image-section-p">
                <img
                    src="https://f.hubspotusercontent40.net/hubfs/8458943/centered-bubble-4.png"
                    alt="Listen to Messages"
                />
            </p>
            <div className="bar" align="center" width="80%" />
            <p className="image-section-p">
                <img src="https://f.hubspotusercontent40.net/hubfs/8458943/centered-bubble-2.png" alt="Make Requests" />
            </p>
            <div className="bar" align="center" width="80%" />
            <p className="image-section-p">
                <img
                    src="https://f.hubspotusercontent40.net/hubfs/8458943/centered-bubble-3.png"
                    alt="Record Activity"
                />
            </p>
            <div className="bar" align="center" width="80%" />
            <div className="social-container">
                <a title="Speak2 Family" href="https://www.facebook.com/speak2family/" target="_blank" rel="noopener">
                    <img
                        src="https://email.speak2family.com/hs/hsstatic/TemplateAssets/static-1.24/img/hs_default_template_images/modules/Follow+Me+-+Email/facebook_circle_color.png"
                        alt="Facebook"
                        width="40"
                        height="40"
                    />
                </a>
                <a
                    title="Speak2 Family"
                    href="https://www.linkedin.com/company/71667950/"
                    target="_blank"
                    rel="noopener"
                >
                    <img
                        src="https://email.speak2family.com/hs/hsstatic/TemplateAssets/static-1.24/img/hs_default_template_images/modules/Follow+Me+-+Email/linkedin_circle_color.png"
                        alt="LinkedIn"
                        width="40"
                        height="40"
                    />
                </a>
                <a title="Speak2 Family" href="http://instagram.com/speak2family" target="_blank" rel="noopener">
                    <img
                        src="https://email.speak2family.com/hs/hsstatic/TemplateAssets/static-1.24/img/hs_default_template_images/modules/Follow+Me+-+Email/instagram_circle_color.png"
                        alt="Instagram"
                        width="40"
                        height="40"
                    />
                </a>
            </div>
            <p className="address">Speak2 Family, 1 Washington Pl 7th floor, Newark, New Jersey 07102, United States</p>
            ​
            <div className="social-container">
                <a
                    className="unsubscribe"
                    href="https://email.speak2family.com/hs/manage-preferences/unsubscribe-all-test?d=VmYj7J62B53-VKgD3Q3_YlyBW2m3bL73_YlyBN1JxwY5GKd_PV20N5W5KfvvPW4v0vrq7NWXypMmM_TC1TVWQ1&amp;v=3"
                    target="_blank"
                    rel="noopener"
                    data-unsubscribe="true"
                    data-hs-link-id="0"
                >
                    Unsubscribe
                </a>
                &nbsp;
                <a
                    className="unsubscribe"
                    href="https://email.speak2family.com/hs/manage-preferences/unsubscribe-test?d=VmYj7J62B53-VKgD3Q3_YlyBW2m3bL73_YlyBN1JxwY5GKd_PV20N5W5KfvvPW4v0vrq7NWXypMmM_TC1TVWQ1&amp;v=3"
                    target="_blank"
                    rel="noopener"
                    data-unsubscribe="true"
                    data-hs-link-id="0"
                >
                    Manage preferences
                </a>
            </div>
        </div>
    );
};
export default AlexaUserInvitationConfirmationPage;
